module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/estimate_2-d0dfa824ceeded356c3fa9b2e6956ff2.jpg";